import { apiGet, apiPut, apiDelete } from './api';

export const aiConfigService = {
  getDefault: () => apiGet('user/ai-config/default'),
  setDefault: (connectionId) => apiPut('user/ai-config/default', { connectionId }),
  clearDefault: () => apiDelete('user/ai-config/default'),
};
